module.exports = __webpack_public_path__ + "static/media/sneha_desu_banner_mobile.8bb5ea65.jpg";